<div class="fetch-action-container">
    <h3 class="section-title">
        <mat-icon>download</mat-icon>
        Fetch Camera Events
    </h3>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="fetch-form">

        <!-- Master Controller -->
        <mat-form-field class="full-width">
            <mat-label>Master Controller</mat-label>
            <mat-select formControlName="masterControllerId">
                @if (isLoadingControllers()) {
                <mat-option disabled>Loading...</mat-option>
                }
                @for (mda of masterControllers(); track mda.id) {
                <mat-option [value]="mda.masterDeviceId">
                    {{ getMasterControllerLabel(mda) }}
                </mat-option>
                }
                @if (!isLoadingControllers() && masterControllers().length === 0) {
                <mat-option disabled>No controllers found</mat-option>
                }
            </mat-select>
            @if (form.get('masterControllerId')?.hasError('required') && form.get('masterControllerId')?.touched) {
            <mat-error>Master controller is required</mat-error>
            }
        </mat-form-field>

        <!-- Date / Time Range -->
        <div class="date-row">
            <mat-form-field>
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="startPicker" formControlName="startDate">
                <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
                @if (form.get('startDate')?.hasError('required') && form.get('startDate')?.touched) {
                <mat-error>Required</mat-error>
                }
            </mat-form-field>

            <mat-form-field>
                <mat-label>Start Time</mat-label>
                <input matInput type="time" formControlName="startTime">
                @if (form.get('startTime')?.hasError('required') && form.get('startTime')?.touched) {
                <mat-error>Required</mat-error>
                }
            </mat-form-field>
        </div>

        <div class="date-row">
            <mat-form-field>
                <mat-label>End Date</mat-label>
                <input matInput [matDatepicker]="endPicker" formControlName="endDate">
                <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
                @if (form.get('endDate')?.hasError('required') && form.get('endDate')?.touched) {
                <mat-error>Required</mat-error>
                }
            </mat-form-field>

            <mat-form-field>
                <mat-label>End Time</mat-label>
                <input matInput type="time" formControlName="endTime">
                @if (form.get('endTime')?.hasError('required') && form.get('endTime')?.touched) {
                <mat-error>Required</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Submit -->
        <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || isSubmitting() || isPending"
            class="submit-btn">
            @if (isSubmitting() || isPending) {
            <mat-spinner diameter="18"></mat-spinner>
            {{ isPending ? 'Fetching from device...' : 'Sending...' }}
            } @else {
            <ng-container>
                <mat-icon>download</mat-icon>
                Fetch Records
            </ng-container>
            }
        </button>
    </form>

    <!-- Status Area -->
    @if (currentFetch(); as fetch) {
    <div class="status-area" [class]="'status-' + fetch.status?.toLowerCase()">
        <div class="status-header">
            @if (isPending) {
            <mat-spinner diameter="16"></mat-spinner>
            }
            @if (isCompleted) {
            <mat-icon class="status-icon completed">check_circle</mat-icon>
            }
            @if (isFailed) {
            <mat-icon class="status-icon failed">error</mat-icon>
            }
            <span class="status-label">{{ fetch.status }}</span>
            @if (fetch.recordCount != null) {
            <span class="record-count">{{ fetch.recordCount }} records</span>
            }
        </div>
        @if (fetch.errorMessage) {
        <p class="error-msg">{{ fetch.errorMessage }}</p>
        }
        @if (fetch.completedAt) {
        <p class="completed-at">Completed: {{ fetch.completedAt | date:'short' }}</p>
        }
    </div>
    }
</div>